import React from 'react';
import {resolveAuthMode} from '../../auth/authMode';
import Resource from '../../core/serverresource';
import AdfsCountdownInfo from './adfs/AdfsCountdownInfo';
import EntraIdCountdownInfo from './entraId/EntraIdCountdownInfo';

interface CountdownInfoProps {
    expireTime?: Date | null;
    className?: string;
    onExpire?: () => void;
    adfsOnly?: boolean;
}

/** Chooses the authentication-specific diagnostic countdown; Entra expiry is not a logout deadline. */
const CountdownInfo = ({expireTime, className, onExpire, adfsOnly = false}: CountdownInfoProps): JSX.Element | null => {
    const mode = resolveAuthMode({
        storage: window.sessionStorage,
        searchParams: new URLSearchParams(window.location.search),
        isEntraIdForced: Resource.isEntraIdForced(),
    });

    if (mode === 'entra-id') {
        return adfsOnly ? null : <EntraIdCountdownInfo className={className}/>;
    }

    return <AdfsCountdownInfo expireTime={expireTime} className={className} onExpire={onExpire}/>;
};

export default CountdownInfo;
